import DolozkaVplyvovEditPage from './DolozkaVplyvovEditPage';

export default DolozkaVplyvovEditPage;
